import React, { useState } from 'react';
import { post } from '../../Services/http';
import { translate } from '../../Services/translation';

const DownloadChargePDFs = (props) => {
    const [inProgress, setinProgress] = useState(false);
    const [error, seterror] = useState("");

    const downloadAllCertificates = () => {   
        setinProgress(true);
        post('/api/orderhistory/downloadchargepdfs', props.pdfs )
        .then((response) => response.blob())
                .then((blob) => {          
                    setinProgress(false);
                    // Create a URL for the blob
                    const url = window.URL.createObjectURL(blob);

                    // Create a link element to trigger the download
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `BE_${props.orderId}.zip`;
                    a.click();

                    // Revoke the object URL to free up resources
                    window.URL.revokeObjectURL(url);
                })
        .catch((ex) => {
            setinProgress(false);
            ex.response.json().then((error) => {
                seterror(error['chargepdfsdownloaderror']);
            })
        });
    }

    return (
        <>
            {error && <div className='error'>{decodeURIComponent(error)}</div>}
            <div className='download-chargepdf'>
                <a className={`button ${(props.pdfs && !inProgress ? '' : 'button--disabled')}`} onClick={() => downloadAllCertificates()}>
                    <svg>
                        <use href="/ui/images/sprites/be-group.svg?v=9#download"></use>
                    </svg>
                    {translate("orderhistory.downloadchargepdfs.text")}
                </a>
            </div>
        </>
    )

}


export default DownloadChargePDFs;